<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :model="form" :inline="true" size="mini" label-width="100px">
          <el-form-item label="商品编码:">
            <el-input v-model="form.goodsCode" clearable></el-input>
          </el-form-item>
          <el-form-item label="商品名称:">
            <el-input v-model.trim="form.goodsName"></el-input>
          </el-form-item>
          <el-form-item label="商品定位:">
            <el-select v-model="form.location" filterable>
              <el-option label="全部" value="" />
              <el-option v-for="item in goodsAttrLocationSelect" :label="item.optionValue" :key="item.optionValue" :value="item.optionValue"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="品类:">
            <el-select v-model="form.category" filterable>
              <el-option label="全部" value="" />
              <el-option v-for="item in categoryList" :label="item.optionValue" :key="item.optionValue" :value="item.optionValue"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="风格:">
            <el-select v-model="form.style" filterable>
              <el-option label="全部" value="" />
              <el-option v-for="item in styleList" :label="item.optionValue" :key="item.optionValue" :value="item.optionValue"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上市时间:">
            <el-date-picker
              v-model="marketOnDateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              unlink-panels
              @change="onDateRangeChange"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="所属类型:">
            <el-select v-model="form.type">
              <el-option label="全部" value=""/>
              <el-option v-for="(item, index) in types" :key="index" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属店铺:">
            <el-select v-model="form.aclass" filterable>
              <el-option label="全部" value=""/>
              <el-option v-for="(item, index) in shopOptions" :key="index" :label="item.shopName" :value="item.shopName"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" @click="handleSearch" size="mini">搜索</el-button>
          <el-button class="orange-btn" @click="resetForm" size="mini">重置</el-button>
        </template>
      </search-box>
    </template>

    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="deliveryCycle">后端发货周期</el-button>
        <el-button type="primary" size="mini" @click="add">新增</el-button>
        <el-button type="primary" size="mini" @click="importExcel">导入</el-button>
        <el-button type="primary" size="mini" @click="importImg()">导入图片</el-button>
        <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
      </template>

      <el-table :data="tableData" :height="maxTableHeight" border v-if="tableReload" v-loading="loading">
        <el-table-column :resizable="true" label="图片" prop="">
          <template slot-scope="scope">
            <template v-if="scope.row.hasPhotos === '有' && scope.row.oneToOneFlag === '是'">
              <el-button size="mini" type="text" @click="viewImg(scope.row)">查看</el-button>
            </template>
            <template v-if="scope.row.hasPhotos === '有' && scope.row.oneToOneFlag === '否'">
              <el-button size="mini" type="text" @click="viewImg(scope.row)">查看</el-button>
              <el-button size="mini" @click="showUpload(scope.row, 1)" type="text">替换</el-button>
            </template>
            <template v-if="scope.row.hasPhotos === '无' && scope.row.oneToOneFlag === '否'">
              <el-button size="mini" @click="showUpload(scope.row, 0)" type="text">上传</el-button>
            </template>
            <template v-if="scope.row.hasPhotos === '无' && scope.row.oneToOneFlag === '是'">
              <el-button size="mini" type="text" @click="showMessage(scope.row.productCode)">请上传产品【{{ scope.row.productCode }}】图片</el-button>
            </template>
          </template>
        </el-table-column>
        <el-table-column :resizable="true" :show-overflow-tooltip="true" label="商品编码" prop="goodsCode" min-width="110"></el-table-column>
        <el-table-column :resizable="true" :show-overflow-tooltip="true" label="商品名称" prop="goodsName" min-width="150"></el-table-column>
        <el-table-column :resizable="true" :show-overflow-tooltip="true" label="69码" prop="snCode" width="100"></el-table-column>
        <el-table-column :resizable="true" :show-overflow-tooltip="true" label="商品定位" prop="location"></el-table-column>
        <el-table-column resizable :show-overflow-tooltip="true" prop="type" width="100" label="所属类型"></el-table-column>
        <el-table-column resizable :show-overflow-tooltip="true" prop="aclass" width="100" label="所属店铺"></el-table-column>
        <el-table-column :resizable="true" :show-overflow-tooltip="true" label="品类" prop="category"></el-table-column>
        <el-table-column :resizable="true" :show-overflow-tooltip="true" label="风格" prop="style"></el-table-column>
        <el-table-column :resizable="true" :show-overflow-tooltip="true" label="上市日期" width="100" prop="marketOn"></el-table-column>
        <el-table-column prop="startDate" label="开始时间" width="100" :show-overflow-tooltip="true" />
        <el-table-column prop="deliveryCycle" label="发货周期" width="100" :show-overflow-tooltip="true" />
        <el-table-column prop="skuPromotionName" label="SKU推广名称" width="110" :show-overflow-tooltip="true" />
        <el-table-column :resizable="true" :show-overflow-tooltip="true" label="更新人" prop="updatedBy"></el-table-column>
        <el-table-column :resizable="true" :show-overflow-tooltip="true" label="更新时间" width="160" prop="updatedDate"></el-table-column>
        <el-table-column :resizable="true" label="操作" align="center" fixed="right" width="130">
          <template slot-scope="scope">
            <el-button type="text" @click="edit(scope.row)">编辑</el-button>
            <el-button type="text" @click="adjusting(scope.row)">调整记录</el-button>
          </template>
        </el-table-column>
      </el-table>

      <template v-slot:footer>
        <div style="text-align: right;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.pageIndex"
            :page-sizes="page.sizes"
            :page-size="page.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="page.total"
          >
          </el-pagination>
        </div>
      </template>
    </table-panel>

    <!-- dialog -->
    <add-edit-dialog
      :visible.sync="dialogVisible"
      :row="rowData"
      :clearanceStatus="clearanceStatus"
      :styleList="styleList"
      :categoryList="categoryList"
      :aClassSelect="aClassSelect"
      :goodsAttrLocationSelect="goodsAttrLocationSelect"
      :shopOptions="shopOptions"
      :types="types"
      ref="addEditDialog"
      @success="onDialogSuccess"
      @notify-open="handleNotifyOpen"
    />

    <!-- 查看图片弹窗 -->
    <el-dialog title="图片查看" :visible.sync="imgFormVisible" :close-on-click-modal="false" width="50%" v-esc-close><imgShow :imgList="imgList"></imgShow></el-dialog>

    <!-- 上传图片弹窗 -->
    <el-dialog title="上传视频及图片" :visible.sync="imgUploadFormVisible" :close-on-click-modal="false" width="60%">
      <imgUpload @save="saveImg" @cancel="imgUploadFormVisible = false" :imgListProp="imgListProp" :typeProp="upType" :disableVideo="true"></imgUpload>
    </el-dialog>
    <!-- 调整记录 -->
    <adjusting-records :visible.sync="isShowAdjusting" v-if="isShowAdjusting" :rowData="rowData" />
    <delivery-cycle :visible.sync="isShowDelivery" v-if="isShowDelivery" :formData="form" @success="init"/>
    <!-- 上传通知店铺 -->
    <notify-store-dialog :visible.sync="showNotifyDialog" v-if="showNotifyDialog" @confirm="handleNotifyConfirm" />
  </content-panel>
</template>

<script>
import addEditDialog from "./components/add-edit-dialog.vue";
import adjustingRecords from "./components/adjustingRecords.vue";
import deliveryCycle from "./components/deliveryCycle.vue";
import imgShow from "@/views/components/imgShow";
import imgUpload from "@/views/components/imgUpload";
import notifyStoreDialog from '@/components/notify-store-dialog/notify-store-dialog';
import { FILE_TYPE } from "@/utils/Global";
import pagePathMixin from '@/utils/page-path-mixin';
import tableMixin from '@/utils/tableMixin';

export default {
  name: "baseattr",
  mixins: [pagePathMixin, tableMixin],
  components: { addEditDialog, imgShow, imgUpload, adjustingRecords, deliveryCycle, notifyStoreDialog },
  data() {
    return {
      loading: false,
      form: {
        location: "",
        aclass: "",
        category: "",
        style: "",
        clearanceStatus: "",
        type: "",
        goodsCode: "",
        goodsName: "",
      },
      marketOnDateRange: [],
      tableReload: true,
      tableData: [],
      dialogVisible: false,
      dialogConfig: {
        title: "编辑",
        width: "60%",
        showButton: false,
      },
      rowData: {},
      formData: {},
      page: {
        pageIndex: 1,
        pageSize: 30,
        sizes: [30, 100, 500, 1000],
        total: 0,
      },
      dialogType: "",
      // 图片查看&上传
      imgFormVisible: false,
      imgList: [],
      // 图片上传弹窗
      imgUploadFormVisible: false,
      isShowAdjusting: false,
      showNotifyDialog: false,
      upType: 0,
      currentRow: [],
      imgListProp: [],
      /**
       * 下拉选项
       */
      // 清仓销售状态
      clearanceStatus: [],
      // 风格
      styleList: [],
      // 品类
      categoryList: [],
      // A类
      aClassSelect: [],
      // 商品定位
      goodsAttrLocationSelect: [],
      // 空间
      goodsPlaceSelect: [],
      // 所属店铺
      shopOptions: [],
      // 所属类型
      types: [],
      fullscreenLoading: false,
      isShowDelivery: false,
      isNotify: false,
      notifyForm: {}
    };
  },
  mounted() {
    this.init();
    this.getOptionType();
    this.get_aClassSelect();
    this.get_goodsAttrLocationSelect();
    this.get_goodsPlaceSelect();
    this.get_shopOptions();
    this.get_types();
  },
  methods: {
    onDateRangeChange(val) {
      if (val && val.length === 2) {
        this.form.marketOnBegin = val[0];
        this.form.marketOnEnd = val[1];
      } else {
        this.form.marketOnBegin = '';
        this.form.marketOnEnd = '';
      }
    },
    resetForm() {
      this.form = {
        location: "",
        aclass: "",
        category: "",
        style: "",
        clearanceStatus: "",
        type: "",
        goodsCode: "",
        goodsName: "",
      };
      this.marketOnDateRange = [];
      this.page.pageIndex = 1;
      this.init();
    },
    showMessage(data) {
      this.$copie(data);
    },
    handleSearch() {
      let goodsCode = this.form.goodsCode && this.form.goodsCode.split(" ").length > 1000;
      if(goodsCode) {
        this.$message.error('已超过1000条，请核对！');
        return;
      }
      this.page.pageIndex = 1;
      this.init();
    },
    init() {
      this.loading = true;
      let data = {
        exportTag: false,
        filterData: {
          ...this.form,
          goodsCode: '',
          goodsCodeList: this.form.goodsCode ? this.form.goodsCode.split(' ') : [],
        },
        pageNum: this.page.pageIndex,
        pageSize: this.page.pageSize,
      };
      this.formData = data;
      this.$q.goods
        .baseAttrManager({ data })
        .then((res) => {
          if (res.code == 200 && res.data.records) {
            this.tableData = res.data.records;
            this.page.total = res.data.total;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    deliveryCycle() {
      if(!this.form.goodsCode) {
        this.$message.error('请输入商品编码后在进行操作！')
        return
      }
      this.isShowDelivery = true
    },
    add() {
      this.dialogType = "modify";
      this.rowData = null;
      this.dialogVisible = true;
    },
    edit(data) {
      this.dialogType = "modify";
      this.rowData = data;
      this.dialogVisible = true;
    },
    adjusting(row) {
      this.rowData = row;
      this.isShowAdjusting = true;
    },
    handleNotifyOpen(formData, originalRow) {
      // 保存当前表单数据用于通知店铺
      this.currentFormData = formData;
      this.currentOriginalRow = originalRow;
      this.isNotify = false;
      this.showNotifyDialog = true;
    },
    handleNotifyConfirm(data) {
      this.notifyForm = data;
      this.isNotify = true;
      // 调用子组件的提交方法
      this.$refs.addEditDialog.submitAndNotify().then(() => {
        if (this.isNotify) {
          this.notifyStore();
        }
      });
    },
    notifyStore() {
      this.isNotify = false;
      let formData = this.currentFormData;
      let itemAOList = [{
        skuCode: formData.goodsCode,
        adjustBefore: this.currentOriginalRow ? this.currentOriginalRow.skuPromotionName : '',
        adjustAfter: formData.skuPromotionName,
      }];
      let data = {
        ...this.notifyForm,
        adjustContent: 'SKU推广名称',
        skuPromotionName: formData.skuPromotionName,
        itemAOList: itemAOList
      };
      this.$q.goods
        .saveMsgNotice({ data: data })
        .then((res) => {
          if (res.success) {
            if (this.notifyForm.noticeTime == 0) {
              this.$store.dispatch('menu/getMenusNum', {}, { root: true });
            }
          }
        })
        .finally((_) => {
          this.init();
        });
    },
    onDialogSuccess() {
      this.init();
      if (this.isNotify) {
        this.notifyStore();
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.page.pageSize = val;
      this.page.pageIndex = 1;
      this.init();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page.pageIndex = val;
      this.init();
    },
    // 查看图片
    viewImg(row) {
      this.imgFormVisible = true;
      this.imgList = [];
      const list = row.imgUrlList;
      for (const item of list) {
        this.imgList.push(item.path);
      }
    },

    // 显示图片上传
    showUpload(row, type) {
      this.currentRow = row;
      this.imgListProp = (row.imgUrlList && [...row.imgUrlList]) || [];
      this.imgUploadFormVisible = true;
      this.upType = type;
    },

    // 保存已上传的图片
    saveImg(data) {
      this.imgUploadFormVisible = false;
      for (let s of data) {
        s.relationId = this.currentRow.goodsId;
      }
      this.editData = { imgList: data, code: this.currentRow.goodsCode };
      this.editDeliveryCycle();
    },
    editDeliveryCycle() {
      this.$q.goods
        .imgEdit({ data: JSON.stringify(this.editData) })
        .then((res) => {
          this.editData = {};
          this.init();
          this.$message.success("操作成功");
        })
        .catch((error) => {
          this.$message.error(error.message);
        });
    },
    // 图片导入
    importImg() {
      this.openSubPage({
        path: "/importImg",
        name: "ImportImg",
        query: {
          fileType: FILE_TYPE.商品图片,
        },
      });
    },
    // 导入
    importExcel() {
      this.openSubPage({
        path: "/goods/goodsBaseattrImport",
        query: {
          fileName: "商品基础属性模板.xlsx",
          appCode: "ec-pc-api",
          reportName: 'goodsBaseAttrImport'
        },
      });
    },
    // 导出
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.form.pageNum = 1;
      this.form.pageSize = 2147483647;
      this.form.exportTag = true;
      let params = {
        appCode: "ec-pc-api",
        paramMap: {
          ...this.formData.filterData,
        },
        reportName: "goodsBaseAttrManagerExport",
      };
      this.$q.orderDate.importExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success("提交下载任务成功，请稍后到导出列表查阅！");
        } else {
          this.$message.error(res.message);
        }
      }).finally(_=>{
        loading.close()
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    /**
     * 下拉选项
     */
    // 获取风格下拉选项
    getOptionType() {
      this.$q.goods.goodsQueryOptionType().then((res) => {
        this.stores = res.data.storeList;
        this.clearanceStatus = res.data.saleStatusList;
        this.styleList = res.data.styleList;
        this.categoryList = res.data.categoryList;
      });
    },
    // A类下拉数据
    get_aClassSelect() {
      this.$q.goods.aClassSelect().then((res) => {
        this.aClassSelect = res.data;
      });
    },
    // (商品属性维护页面搜索)商品定位下拉数据
    get_goodsAttrLocationSelect() {
      this.$q.goods.goodsAttrLocationSelect().then((res) => {
        this.goodsAttrLocationSelect = res.data;
      });
    },
    // 商品空间下拉数据
    get_goodsPlaceSelect() {
      this.$q.goods.goodsPlaceSelect().then((res) => {
        this.goodsPlaceSelect = res.data;
      });
    },
    // 所属店铺下拉数据
    get_shopOptions() {
      this.$q.product.storeSelect().then((res) => {
        this.shopOptions = res.data;
      });
    },
    // 所属类型
    get_types() {
      this.$q.product.getType().then((res) => {
        this.types = res.data;
      });
    },
  },
};
</script>

<style lang="stylus" scoped></style>
